import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardActionArea,
  CardContent
} from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';
import { RegisterUsabilityLog } from '../../../shared/data-services/ModuleUsabilityLog-service';

const ContentEcuador = ({ user }) => {
  const name = user.name;
  const navigate = useNavigate();

  const handleQuickAccess = async (route, logText) => {
    await RegisterUsabilityLog(logText, user.employeeId);
    navigate(route);
  };
  
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ color: '#8ebb37', fontWeight: 'bold', m: 1 }}>
                <b>¡Hola {name}!</b>
              </Typography>
              <Typography variant="h5" sx={{ color: '#1a3072', fontWeight: 'bold', m: 1 }}>
                <i>Bienvenido a la plataforma Tu Experiencia <span style={{ color: '#00b0ef' }}><b>Talma</b></span></i>
              </Typography>
            </Grid>

          {/* Video */}
          <Grid item xs={12} sx={{ mb: 3 }}>
            <iframe
              width="100%"
              height="415"
              src="https://www.youtube.com/embed/muy1rjjA21A"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </Grid>

          {/* Botones */}
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center" alignItems="stretch" sx={{ mt: 2 }}>

              {/* Botón: Mis Turnos */}
              <Grid item xs={12} sm={6} md={4}>
                <Card sx={{ width: "100%", height: "100%", backgroundColor: "#00000008" }}>
                  <CardActionArea
                    onClick={() => handleQuickAccess('/ShiftCalendar', 'Mis Turnos - Autogestión')}
                    sx={{
                      textAlign: "center",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}
                  >
                    <CalendarMonthIcon sx={{ fontSize: 60, color: "#27b9d4", mt: 2 }} />
                    <CardContent sx={{ p: 0, minHeight: 80 }}>
                      <Typography variant="h6" sx={{ color: "#8ebb37", fontWeight: "bold", textAlign: 'center' }}>
                        Consulta de
                      </Typography>
                      <Typography variant="h6" sx={{ color: "#1a3072", fontWeight: "bold", textAlign: 'center' }}>
                        Mis Turnos
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Columna derecha: imagen */}
      <Grid item xs={12} md={6}>
        <img src="./Images/hom_tu_experiencia.jpg" alt="logo" style={{ width: '100%', height: '90%' }} />
      </Grid>
    </Grid>
  </>
);

};

export default ContentEcuador;
